var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FB6F80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.55 13.875C28.2875 13.875 26.2625 14.975 25 16.6625C23.7375 14.975 21.7125 13.875 19.45 13.875C15.6125 13.875 12.5 17 12.5 20.8625C12.5 22.35 12.7375 23.725 13.15 25C15.125 31.25 21.2125 34.9875 24.225 36.0125C24.65 36.1625 25.35 36.1625 25.775 36.0125C28.7875 34.9875 34.875 31.25 36.85 25C37.2625 23.725 37.5 22.35 37.5 20.8625C37.5 17 34.3875 13.875 30.55 13.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.835ee1854cef0b3df11880269b350f25.svg";
export { ForwardRef as ReactComponent };